<template>

  <div class="relative">
    <nuxt-img :src="backgroundImage"
      class="object-cover absolute top-0 left-0 z-0 w-full h-full monitor-only:object-fill" alt="Mind Flow Background"
      fetchpriority="high" loading="eager" preload width="1499" height="1920"
      sizes="sm:100vwmd:100vw lg:100vw xl:100vw" />

    <div class="grid relative z-10 pb-8 mx-auto max-w-7xl md:pt-10 xl:pt-20 md:pb-10">
      <div class="px-4">
        <svg width="345" height="133" class="mx-auto w-52 xl:w-auto sm:w-72 md:mx-0" viewBox="0 0 345 133" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M28.5411 77.3789C21.0838 82.2394 17.9087 89.3559 16.882 97.7752C16.6168 99.9498 16.8326 102.143 16.3657 104.294C16.0802 105.61 15.5443 106.647 14.0312 106.588C12.4872 106.527 12.0376 105.402 11.9606 104.078C11.6164 98.1606 12.7574 92.4987 15.0302 87.0593C17.2166 81.8265 20.2981 77.0829 23.2689 72.282C24.5866 70.1525 24.5381 70.2137 22.6321 68.738C9.90074 58.8807 2.4511 45.8695 0.487248 29.9768C-0.433317 22.527 -0.140808 14.9463 2.15462 7.62694C2.77525 5.64797 3.59863 3.76063 4.71887 2.01173C6.27679 -0.42047 7.26564 -0.588204 9.53871 1.18944C18.0953 7.88105 24.4208 16.2758 28.6397 26.269C29.4575 28.206 30.2065 30.172 31.144 32.5166C32.6211 29.7071 32.6706 27.0994 32.2716 24.4946C31.8111 21.489 30.4897 18.8385 28.4 16.5974C28.193 16.3754 27.9849 16.1522 27.8007 15.9116C27.1586 15.0725 26.5211 14.1459 27.0259 13.0839C27.5586 11.9634 28.745 12.285 29.6432 12.3902C34.6976 12.9824 39.5704 14.3234 43.8998 17.0244C48.6621 19.9955 53.9424 21.1838 59.3195 22.2023C62.7799 22.8578 66.189 23.7178 69.5038 24.9161C70.1815 25.1611 70.8773 25.4607 71.4401 25.8963C72.4981 26.7152 72.287 27.7694 71.0152 28.2153C70.0907 28.5395 69.1136 28.5459 68.1388 28.5904C62.9949 28.8254 57.8297 28.8256 52.7692 30.0032C51.5753 30.281 50.4484 30.709 49.3434 31.2119C46.1994 32.643 44.9608 34.9476 45.5377 38.4058C46.2984 42.965 46.8786 47.5224 46.2588 52.1585C45.2223 59.9112 41.4619 66.1809 35.8871 71.4938C33.6374 73.6379 31.1435 75.471 28.5411 77.3789ZM10.2874 6.45194C10.0671 6.24311 9.8502 6.03058 9.62599 5.82604C7.9519 4.29888 7.51597 4.39457 6.74162 6.46994C6.57213 6.92419 6.41888 7.38572 6.28329 7.85122C4.0507 15.5166 3.87229 23.3122 5.34667 31.0814C7.65879 43.2652 12.7543 54.1346 21.535 63.0764C22.8688 64.4347 24.2833 65.7759 26.1624 66.5587C26.4153 66.2004 26.62 65.9775 26.7495 65.7171C30.0047 59.1706 31.2729 52.2294 30.0911 45.0377C27.6498 30.1817 21.1941 17.2967 10.2874 6.45194ZM36.1604 27.8416C35.9587 30.2263 35.2367 32.4654 34.3522 34.6765C33.5562 36.6663 33.2439 38.6938 33.6284 40.8937C34.3786 45.1856 35.1717 49.476 34.6201 53.9009C33.6911 61.3532 30.6619 67.9521 26.6823 74.2127C26.7848 74.2276 26.855 74.2608 26.8856 74.2388C27.3779 73.8856 27.8665 73.527 28.3536 73.1664C34.6905 68.4747 39.4579 62.636 41.326 54.8229C42.6611 49.2388 41.8603 43.5919 41.4049 37.9732C41.0965 34.1686 42.2007 31.0372 45.528 28.8854C45.9917 28.5856 46.6815 28.433 46.683 27.5957C45.3793 27.22 44.3541 28.2136 43.1515 28.2486C41.7459 28.2895 40.8305 27.6252 40.2613 26.4392C39.6721 25.2114 40.6182 24.8874 41.4698 24.4764C41.7646 24.3341 42.0278 23.9863 42.1589 23.6714C42.5341 22.7699 43.263 22.7657 43.9855 22.9535C44.7429 23.1503 45.461 23.5 46.1935 23.7899C50.6766 25.5645 55.3657 25.7626 60.0939 25.6761C57.2535 25.039 54.3865 24.5714 51.5377 24.0109C47.0037 23.1188 43.1027 20.6507 38.9286 18.861C37.1114 18.0819 35.2977 17.252 32.9169 17.0702C35.0941 20.4072 36.4245 23.737 36.1604 27.8416Z"
            fill="black" />
          <path
            d="M230.558 122.207C227.947 122.207 225.517 122.248 223.09 122.191C221.715 122.159 221.376 122.766 221.674 123.99C222.224 126.251 223.516 127.737 225.854 128.294C228.02 128.81 230.072 128.392 231.222 126.601C232.519 124.582 233.988 125.292 235.739 125.432C235.204 128.407 233.531 130.225 231.028 131.198C224.291 133.817 216.882 129.63 216.917 121.976C216.931 118.925 217.283 116.046 219.265 113.582C222.005 110.177 226.587 108.983 230.601 110.717C235.026 112.629 236.392 116.528 236.376 120.777C236.372 121.854 235.801 122.257 234.748 122.216C233.414 122.164 232.076 122.205 230.558 122.207ZM225.295 113.674C222.759 114.652 221.738 116.115 221.931 118.659C225.317 118.691 228.714 118.873 232.123 118.559C231.736 114.902 229.455 113.242 225.295 113.674Z"
            fill="black" />
          <path
            d="M248.472 131.984C238.886 131.139 237.161 121.588 240.086 115.369C241.844 111.629 246.025 109.424 249.971 110.026C254.597 110.731 257.427 113.639 258.04 118.316C258.548 122.194 258.548 122.197 254.764 122.203C251.488 122.209 248.212 122.241 244.937 122.195C243.542 122.175 243.262 122.79 243.569 124.008C244.202 126.522 245.788 128.016 248.33 128.381C250.456 128.687 252.373 128.136 253.512 126.189C254.665 124.219 256.126 125.618 257.498 125.355C257.013 129.438 253.885 131.69 248.472 131.984ZM248.938 113.477C246.006 113.262 243.354 115.921 243.753 118.688C246.903 118.688 250.093 118.709 253.284 118.674C254.17 118.665 254.175 118.037 253.965 117.371C253.233 115.046 251.673 113.73 248.938 113.477Z"
            fill="black" />
          <path
            d="M185.385 112.966C189.478 117.789 189.26 125.592 184.905 129.409C181.625 132.284 177.784 132.768 173.858 131.082C170.074 129.457 168.123 126.45 168.06 122.209C168.013 119.044 168.2 116.008 170.356 113.46C174.099 109.039 180.636 108.784 185.385 112.966ZM175.37 114.378C172.262 116.048 171.846 119.999 172.594 123.621C173.297 127.023 175.555 128.482 178.955 128.174C181.558 127.938 183.503 125.718 183.765 122.634C183.831 121.852 183.807 121.06 183.797 120.274C183.731 115.088 180.624 112.805 175.37 114.378Z"
            fill="black" />
          <path
            d="M146.635 119.647C147.356 111.645 153.899 108.836 159.487 110.357C162.782 111.253 164.885 113.701 165.206 117.062C162.965 118.003 161.779 117.683 160.605 115.819C158.774 112.915 153.609 113.194 152.05 116.379C150.544 119.453 150.71 122.654 152.204 125.68C153.068 127.43 154.668 128.234 156.705 128.207C158.643 128.183 160.177 127.531 161.019 125.753C162.114 123.438 163.72 125.239 165.292 124.972C164.911 127.635 163.611 129.403 161.53 130.634C155.108 134.432 147.156 130.108 146.65 122.545C146.589 121.639 146.633 120.725 146.635 119.647Z"
            fill="black" />
          <path
            d="M192.916 106.139C194.246 103.094 197.906 101.546 200.868 102.551C202.011 102.939 201.837 103.773 201.842 104.608C201.85 105.759 201.061 105.766 200.22 105.79C197.525 105.867 196.773 106.624 196.793 109.05C196.801 109.952 197.118 110.428 198.054 110.416C198.661 110.409 199.271 110.39 199.874 110.44C200.717 110.51 201.894 110.182 201.787 111.668C201.702 112.848 201.54 114.046 199.842 113.845C199.423 113.796 198.99 113.873 198.569 113.836C197.226 113.718 196.756 114.317 196.771 115.649C196.824 120.323 196.728 124.999 196.825 129.672C196.862 131.421 196.025 131.647 194.6 131.639C193.22 131.632 192.47 131.349 192.5 129.721C192.585 125.109 192.507 120.494 192.541 115.88C192.55 114.66 192.491 113.677 190.859 113.807C189.964 113.878 189.747 113.199 189.76 112.471C189.773 111.712 189.575 110.579 190.623 110.563C192.499 110.534 192.603 109.471 192.569 108.071C192.555 107.479 192.774 106.881 192.916 106.139Z"
            fill="black" />
          <path
            d="M211.341 124.653C211.34 126.473 211.261 128.117 211.362 129.749C211.465 131.409 210.563 131.633 209.223 131.63C207.914 131.627 207.039 131.51 207.075 129.792C207.174 125.122 207.073 120.447 207.129 115.775C207.146 114.442 206.872 113.664 205.336 113.821C204.134 113.944 203.965 113.113 203.981 112.167C203.997 111.241 204.15 110.37 205.334 110.459C206.861 110.573 207.158 109.804 207.124 108.475C206.987 103.192 211.011 102.14 214.666 102.409C216.001 102.508 216.108 103.367 216.115 104.448C216.122 105.659 215.473 105.837 214.489 105.795C213.398 105.748 212.276 105.665 211.63 106.878C210.576 108.858 211.449 110.346 213.674 110.449C214.454 110.485 215.746 109.957 215.713 111.457C215.684 112.757 215.404 114.101 213.54 113.835C211.755 113.579 211.234 114.368 211.314 116.098C211.441 118.883 211.343 121.679 211.341 124.653Z"
            fill="black" />
          <path
            d="M171.073 83.592C171.057 72.2569 171.084 61.0953 171.009 49.9344C170.998 48.2106 171.597 47.7224 173.22 47.8162C177.267 48.05 181.341 47.46 185.375 48.206C186.696 48.4503 187.952 48.886 189.153 49.4729C192.173 50.9489 193.687 53.4677 193.781 56.7411C193.868 59.8099 192.571 62.2542 189.848 63.8443C189.441 64.0825 188.931 64.1997 188.692 64.7466C188.929 65.5325 189.744 65.4411 190.304 65.6403C193.746 66.864 195.997 69.0832 196.369 72.8363C196.754 76.7213 195.362 79.848 192.112 82.0789C189.426 83.9221 186.363 84.6812 183.185 84.823C179.734 84.977 176.271 84.8774 172.814 84.8824C172.004 84.8835 171.176 84.8877 171.073 83.592ZM190.411 76.7559C191.816 71.9167 189.925 68.7491 185.119 67.7123C182.709 67.1925 180.287 67.3986 177.867 67.3172C176.753 67.2797 176.388 67.8312 176.397 68.8811C176.427 72.5204 176.428 76.1601 176.403 79.7994C176.396 80.8293 176.709 81.4147 177.847 81.3872C179.546 81.3463 181.261 81.5017 182.943 81.3247C186.005 81.0023 188.756 80.0006 190.411 76.7559ZM186.611 61.7692C189.968 57.7269 188.369 52.5882 183.356 51.4907C181.455 51.0745 179.496 51.2915 177.56 51.3681C176.703 51.4021 176.417 51.9364 176.417 52.6967C176.417 56.027 176.422 59.3573 176.431 62.6876C176.433 63.2487 176.458 63.8473 177.224 63.8717C180.441 63.9744 183.677 64.1426 186.611 61.7692Z"
            fill="black" />
          <path
            d="M234.028 64.1438C234.28 68.5471 233.841 72.6888 232.009 76.562C229.277 82.3375 224.768 85.4809 218.276 85.6703C211.633 85.8642 206.463 83.2685 203.573 77.258C200.09 70.0139 200.135 62.5168 203.836 55.3529C206.818 49.5803 211.995 46.9387 218.399 47.2322C225.299 47.5484 230.107 51.0978 232.637 57.5989C233.436 59.6517 233.747 61.8086 234.028 64.1438ZM228.185 71.8333C229.281 66.5235 228.917 61.3372 226.689 56.3669C224.967 52.5251 222.037 50.4974 217.695 50.4866C213.402 50.476 210.672 52.6065 208.789 56.2572C207.215 59.3088 206.675 62.6034 206.608 65.9353C206.522 70.2108 207.122 74.3995 209.517 78.1332C213.04 83.6253 220.716 84.1693 224.941 79.1883C226.672 77.1473 227.585 74.7209 228.185 71.8333Z"
            fill="black" />
          <path
            d="M267.548 80.3076C262.955 85.8482 255.272 86.7925 249.483 84.7619C243.525 82.672 239.325 76.5109 239.083 69.8C238.945 65.9826 238.869 62.1886 240.129 58.4694C242.799 50.5891 248.958 46.8993 255.943 47.2524C264.147 47.6672 270.096 53.1134 271.324 60.9598C272.392 67.7824 272.066 74.4069 267.548 80.3076ZM251.745 81.9442C257.047 83.6032 261.384 82.0722 263.917 77.1879C267.529 70.2219 267.354 63.0308 264.196 55.9523C260.936 48.6458 250.293 48.7512 246.945 55.4041C243.706 61.8415 243.481 68.4341 245.712 75.1573C246.695 78.1214 248.459 80.5602 251.745 81.9442Z"
            fill="black" />
          <path
            d="M150.323 47.8365C154.089 47.8334 157.675 47.9052 161.255 47.7934C162.923 47.7413 163.466 48.2953 163.501 49.9583C163.539 51.7712 162.712 52.0733 161.174 52.0395C157.592 51.9608 154.006 52.0536 150.424 51.9773C148.943 51.9458 148.291 52.5348 148.294 53.9754C148.302 56.8291 148.301 59.6829 148.292 62.5366C148.288 63.7398 148.806 64.2754 150.067 64.254C153.224 64.2002 156.384 64.2889 159.541 64.2131C160.967 64.1788 161.306 64.8424 161.287 66.0881C161.269 67.2849 161.003 68.0843 159.57 68.0649C156.473 68.0229 153.373 68.1034 150.278 68.0279C148.825 67.9925 148.178 68.6723 148.335 69.9727C148.673 72.7716 148.275 75.5531 148.276 78.3418C148.277 80.1015 148.798 80.8224 150.695 80.7455C154.334 80.598 157.984 80.7709 161.626 80.6638C163.353 80.613 163.606 81.4105 163.609 82.8691C163.612 84.3163 163.219 84.933 161.659 84.9132C156.072 84.8421 150.483 84.8494 144.896 84.9074C143.44 84.9225 143.007 84.3506 143.012 82.9686C143.047 71.975 143.056 60.9812 143.009 49.9877C143.002 48.3388 143.533 47.6828 145.223 47.813C146.853 47.9386 148.501 47.8376 150.323 47.8365Z"
            fill="black" />
          <path
            d="M287.496 47.144C290.539 46.9738 293.338 47.2798 296.088 48.2083C297.599 48.7183 298.192 49.4536 297.499 51.0034C297.184 51.7091 297.222 52.5568 296.694 53.1736C296.106 53.3244 295.776 52.8932 295.38 52.6446C292.771 51.0069 289.938 50.2855 286.872 50.6194C284.688 50.8572 282.909 51.7933 282.034 53.9336C281.18 56.0207 281.805 57.866 283.183 59.5033C285.034 61.7038 287.604 62.8708 290.078 64.1497C291.914 65.0986 293.741 66.061 295.428 67.2513C301.934 71.843 301.44 80.4249 294.351 84.017C288.948 86.7549 283.426 86.1208 277.988 83.8832C277.196 83.5574 276.891 83.0034 277.05 82.1549C277.262 81.0295 277.413 79.89 278.097 78.6285C280.209 79.9795 282.374 81.1781 284.84 81.5617C287.248 81.9362 289.659 82.1635 291.975 81.0466C295.715 79.2428 296.355 75.2222 293.304 72.4173C291.308 70.582 288.817 69.5469 286.444 68.3342C284.604 67.3941 282.785 66.4337 281.153 65.149C277.975 62.6485 276.418 59.4124 277.221 55.4056C278.034 51.3453 280.748 48.8783 284.664 47.7147C285.531 47.4572 286.439 47.335 287.496 47.144Z"
            fill="black" />
          <path
            d="M122.313 71.7029C122.314 75.5194 122.264 79.1621 122.335 82.8024C122.366 84.3496 121.872 84.958 120.246 84.9225C117.056 84.8526 117.053 84.9342 117.052 81.8177C117.051 71.2565 117.095 60.6951 117.01 50.1346C116.995 48.2712 117.562 47.7601 119.382 47.7949C124.964 47.9019 130.55 47.8763 136.133 47.8014C137.683 47.7806 138.099 48.3598 138.091 49.8217C138.083 51.2918 137.789 52.0815 136.087 52.0406C132.265 51.9487 128.438 52.0719 124.617 51.9728C122.924 51.9288 122.203 52.3914 122.287 54.2136C122.42 57.121 122.363 60.0395 122.308 62.9518C122.284 64.2172 122.769 64.6614 124.021 64.6395C127.237 64.583 130.456 64.6758 133.671 64.6004C135.143 64.5658 135.391 65.3137 135.361 66.5178C135.331 67.6728 135.358 68.7436 133.714 68.7109C130.985 68.6567 128.256 68.7986 125.526 68.5704C122.48 68.3157 122.325 68.4975 122.313 71.7029Z"
            fill="black" />
          <path
            d="M308.713 47.8273C314.969 47.8301 321.043 47.868 327.115 47.8112C328.592 47.7974 329.316 48.0782 329.3 49.7916C329.284 51.4289 328.833 52.1016 327.131 52.0185C324.95 51.9119 322.751 52.1198 320.576 51.968C318.671 51.835 318.23 52.5708 318.245 54.369C318.322 63.7823 318.28 73.1967 318.269 82.6107C318.267 84.8892 318.25 84.8891 315.687 84.8863C312.995 84.8834 312.98 84.8834 312.979 82.547C312.972 73.133 312.922 63.7185 313.017 54.3055C313.036 52.4034 312.402 51.8668 310.615 51.9708C308.436 52.0976 306.241 51.9424 304.058 52.0353C302.404 52.1058 302.009 51.3504 302.009 49.8388C302.009 48.3736 302.434 47.7185 303.977 47.8152C305.489 47.91 307.012 47.8305 308.713 47.8273Z"
            fill="black" />
          <path
            d="M75.6687 82.191C75.6675 71.3929 75.6567 60.7731 75.6863 50.1533C75.6884 49.3886 75.222 48.1922 76.364 47.9781C77.7596 47.7163 79.2926 47.4931 80.6295 48.1682C81.2443 48.4787 80.9662 49.3976 80.9672 50.0454C80.9816 59.3908 80.9791 68.7362 80.9813 78.0817C80.9819 80.7161 80.983 80.7121 83.536 80.7083C87.1771 80.7029 90.8197 80.7654 94.4585 80.6746C96.121 80.6331 96.3101 81.4734 96.3241 82.8163C96.3386 84.2078 96.0448 84.9321 94.4217 84.9087C89.022 84.8308 83.6203 84.8859 78.2194 84.8804C75.7123 84.8778 75.7123 84.8676 75.6687 82.191Z"
            fill="black" />
          <path
            d="M102.972 84.8281C101.891 84.4566 102.042 83.6462 102.041 82.9476C102.028 71.8443 102.045 60.741 102.009 49.6378C102.005 48.3237 102.417 47.7989 103.78 47.8211C107.892 47.8881 107.322 47.5617 107.329 51.2934C107.35 61.4866 107.337 71.6798 107.336 81.8729C107.335 84.9037 107.333 84.9045 104.232 84.8839C103.868 84.8815 103.504 84.8649 102.972 84.8281Z"
            fill="black" />
          <path
            d="M344.148 53.7946C344.147 55.3093 344.101 56.6443 344.159 57.9748C344.208 59.1074 343.632 59.4633 342.626 59.4899C341.608 59.5168 341.026 59.1699 341.034 58.0388C341.057 54.8881 341.057 51.7369 341.02 48.5865C341.007 47.4794 341.497 47.1237 342.555 47.1002C343.74 47.074 344.191 47.5453 344.156 48.7051C344.108 50.3397 344.146 51.9768 344.148 53.7946Z"
            fill="black" />
          <path
            d="M337.006 53.7946C337.006 55.3093 336.959 56.6443 337.017 57.9748C337.066 59.1074 336.491 59.4633 335.484 59.4899C334.466 59.5168 333.885 59.1699 333.893 58.0388C333.915 54.8881 333.916 51.7369 333.879 48.5865C333.866 47.4794 334.355 47.1237 335.414 47.1002C336.598 47.074 337.049 47.5453 337.015 48.7051C336.966 50.3397 337.005 51.9768 337.006 53.7946Z"
            fill="black" />
        </svg>
      </div>

      <h1
        class="mx-auto md:mt-20 mt-4 font-bold text-center text-5xl sm:text-7xl lg:text-8xl xl:text-[108px] mb-8 md:mb-10 font-ww-medium px-4">
        {{ headingTitle }}
      </h1>

      <div class="bg-[#FA8B4B] rounded-3xl px-4 py-3 mx-4">
        <span class="">
          <span class="font-bold font-open-sans text-4xl sm:text-6xl lg:text-7xl xl:text-[100px] leading-none">
            {{ bannerText }}
          </span>
          <span
            class="text-[#FEF46B] text-3xl sm:text-5xl lg:text-58 xl:text-7xl ml-4 relative xl:bottom-2 font-open-sans xl:tracking-[-5px] !leaidng-none font-bold">
            {{ bannerHighlight }}
          </span>
        </span>
      </div>

      <div
        class="px-4 mt-4 text-2xl italic font-semibold !leading-tight text-center md:mt-10 sm:text-4xl lg:text-5xl xl:text-6xl  font-open-sans xl:px-0">
        {{ subHeading }}
      </div>

      <div class="grid grid-cols-12 gap-y-12 px-4 mt-8 sm:mt-20 lg:gap-x-16 xl:px-0">
        <div class="order-2 col-span-12 lg:col-span-7 lg:order-1">
          <form class="bg-[#F9B7B9] rounded-3xl px-4 md:px-8 md:py-14 py-8" id="email_signup_form"
            action="//manage.kmail-lists.com/subscriptions/subscribe"
            data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank"
            novalidate="novalidate">

            <input type="hidden" name="g" :value="klaviyoListId">
            <input type="hidden" name="utf8" value="✓">

            <div class="mb-8 space-y-6 md:space-y-10 md:mb-16">
              <div class="">
                <label for="k_id_name" class="text-2xl font-semibold sm:text-4xl xl:text-5xl font-OpenSans"
                  aria-label="Name">
                  Name
                </label>

                <input name="first_name" id="k_id_name" type="text" placeholder="Your Name" aria-label="Name"
                  autocomplete="given-name" class="w-full p-4 rounded-2xl bg-[#FDDFBC] mt-4 md:h-20 h-16" />
              </div>

              <div class="">
                <label for="k_id_email" class="text-2xl font-semibold sm:text-4xl xl:text-5xl font-OpenSans"
                  aria-label="Email Address">
                  Email
                </label>

                <input aria-required="true" required id="k_id_email" name="email" type="email"
                  placeholder="Email Address" aria-label="Email Address" autocomplete="email"
                  class="w-full p-4 rounded-2xl bg-[#FDDFBC] mt-4 md:h-20 h-16" />
              </div>
            </div>

            <div class="mb-2 klaviyo_messages">
              <div class="success_message" style="display:none;"></div>
              <div class="error_message" style="display:none;"></div>
            </div>

            <button type="submit"
              class="text-[#FEF46B] xl:text-6xl lg:text-5xl sm:text-4xl text-2xl font-bold bg-[#FA8B4B] rounded-2xl px-4 md:py-8 py-4 w-full font-ww-medium">
              {{ ctaButtonText }}
            </button>

          </form>
        </div>


        <div class="flex flex-col order-1 col-span-12 justify-between lg:col-span-5 lg:order-2">
          <img :src="pdfImage" width="334" height="516" class="mx-auto -mt-5 w-auto h-full"
            sizes="sm:369px md:368px lg:368px xl:368px" />


          <div
            class="text-[#FEF46B] text-center xl:text-6xl lg:text-5xl lg:max-w-full max-w-96 mx-auto text-4xl font-bold bg-[#FA8B4B] font-ww-medium rounded-2xl px-4 py-4 w-full">
            {{ pdfButtonText }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="relative z-10 px-4 lg:px-0" style=" background: linear-gradient(
    to top,
    #F8D6A9 0%, 
    #F8D6A9 50%,
    #F8DBB0 100%
  );">
    <div class="pt-8 mx-auto max-w-7xl md:pt-10">
      <div class="grid grid-cols-12 gap-x-6 gap-y-12 md:gap-x-6">
        <div v-for="(feature, index) in features" :key="index" class="col-span-6 md:col-span-3">
          <div>
            <nuxt-img :src="feature.imgSrc" class="mx-auto w-24 sm:w-40 lg:w-48 xl:w-auto" :alt="`Feature ${index + 1}`"
              loading="lazy" width="220" height="221" sizes="sm:128px md:160px lg:160px xl:192px" />
          </div>
          <div
            class="text-xl font-semibold !leading-tight text-center sm:text-2xl lg:text-3xl xl:text-4xl font-open-sans"
            v-html="feature.title">
          </div>
        </div>
      </div>
    </div>

    <div class="relative mt-20">
      <svg 
        v-if="!isVideoPlaying" 
        @click="playVideo"
        class="absolute inset-0 z-10 m-auto w-24 cursor-pointer xl:w-52 md:w-32" 
        xmlns="http://www.w3.org/2000/svg" 
        width="210" 
        height="209" 
        viewBox="0 0 210 209"
        fill="none">
        <path
          d="M0.833496 104.384C0.833496 46.8545 47.4705 0.217529 105 0.217529C162.529 0.217529 209.167 46.8545 209.167 104.384C209.167 161.913 162.529 208.551 105 208.551C47.4705 208.551 0.833496 161.913 0.833496 104.384ZM93.0793 64.3319C84.4012 59.5252 73.7502 65.8017 73.7502 75.7224V133.047C73.7502 142.968 84.4012 149.244 93.0793 144.437L153.056 111.219C155.542 109.843 157.083 107.225 157.083 104.384C157.083 101.544 155.542 98.9269 153.056 97.5498L93.0793 64.3319Z"
          fill="#FA8B4B" />
      </svg>

   <div class="px-4">
    <video 
        ref="videoElement"
        :muted="!isVideoPlaying" 
        playsinline 
        loop 
        preload="none" 
        width="1130" 
        height="600"
        class="object-cover mx-auto rounded-3xl shadow-lg">
        <source type="video/mp4">
        Your browser does not support the video tag.
      </video>
   </div>
    </div>

  </div>



  <div class="-mt-1">
    <nuxt-img src="/assets/images/footer-mind-flow-new.jpg" class="w-full" alt="Mind Flow Background"
      fetchpriority="high" loading="eager" preload width="1499" height="1920"
      sizes="sm:100vw md:100vw lg:100vw xl:100vw" />
  </div>

</template>

<script setup>
import { ref } from 'vue'

// Reactive variables
const isVideoPlaying = ref(false)
const videoElement = ref(null)

// Play video function
const playVideo = () => {
  isVideoPlaying.value = true
  if (videoElement.value) {
    // Add video source when play button is clicked
    const source = videoElement.value.querySelector('source')
    if (source && !source.src) {
      source.src = props.videoUrl
    }
    videoElement.value.load() // Reload video with new source
    videoElement.value.play()
  }
}

onMounted(() => {
  // Load the external Klaviyo script
  const klaviyoScript = document.createElement('script');
  klaviyoScript.src = "//www.klaviyo.com/media/js/public/klaviyo_subscribe.js";
  klaviyoScript.onload = () => {
    // Once the script is loaded, attach the KlaviyoSubscribe
    KlaviyoSubscribe.attachToForms('#email_signup_form', {
      hide_form_on_success: true,
      success_message: "We've sent you a secure download to your email. Please check your email inbox/marketing/spam boxes.",
      extra_properties: {
        $source: '$embed',
        $method_type: "Klaviyo Form",
        $method_id: 'embed',
        $consent_version: 'Embed default text'
      }
    });
  };
  document.body.appendChild(klaviyoScript);
});

// Component props
const props = defineProps({
  headingTitle: {
    type: String,
    default: 'Want A Brain Glow Up?',
  },
  bannerText: {
    type: String,
    default: '4 Tiny Tweaks To Think Faster -',
  },
  bannerHighlight: {
    type: String,
    default: '#1 Takes Just 10 Seconds',
  },
  subHeading: {
    type: String,
    default: 'Notes from a Doctor that has been biohacking his brain for over a decade',
  },
  ctaButtonText: {
    type: String,
    default: 'Yes! I want my copy!',
  },
  pdfButtonText: {
    type: String,
    default: 'PDF',
  },
  backgroundImage: {
    type: String,
    default: '/assets/images/Home-Screen_Option-2.png',
  },
  pdfImage: {
    type: String,
    default: 'https://cdn.shopify.com/s/files/1/0838/4525/files/attachment-Photoroom_1_1.png?v=1746116404',
  },
  videoUrl: {
    type: String,
    default: 'https://cdn.shopify.com/videos/c/o/v/b52e1b2a5b8b4ef1a61db7ad3c949290.mp4',
  },
  features: {
    type: Array,
    default: () => [
      {
        imgSrc: '/assets/images/mind-1.png',
        title: 'Crush Brain <br> Fog in 5 Min',
      },
      {
        imgSrc: '/assets/images/mind-2.png',
        title: 'Beware your <br> Brain <br> (Yes, Even You)',
      },
      {
        imgSrc: '/assets/images/mind-3.png',
        title: '4 Steps to <br> a Glow-Up Brain',
      },
      {
        imgSrc: '/assets/images/mind-4.png',
        title: 'Brainpower <br> You Can Flex IRL',
      },
    ],
  },
  klaviyoListId: {
    type: String,
    default: 'R9KL24',
  },
});

// Builder component schema
defineBuilderComponent({
  friendlyName: 'ContentWithForm',
  schema: {
    category: 'forms',
    icon: 'mdi:form-select',
    color: '#FA8B4B',
    description: 'Landing page with lead capture form and feature highlights',
  },
  inputs: [
    {
      name: 'headingTitle',
      type: 'text',
      friendlyName: 'Main Heading',
      defaultValue: 'Want A Brain Glow Up?',
    },
    {
      name: 'bannerText',
      type: 'text',
      friendlyName: 'Banner Text',
      defaultValue: '4 Tiny Tweaks To Think Faster -',
    },
    {
      name: 'bannerHighlight',
      type: 'text',
      friendlyName: 'Banner Highlight Text',
      defaultValue: '#1 Takes Just 10 Seconds',
    },
    {
      name: 'subHeading',
      type: 'text',
      friendlyName: 'Sub Heading',
      defaultValue: 'Notes from a Doctor that has been biohacking his brain for over a decade',
    },
    {
      name: 'ctaButtonText',
      type: 'text',
      friendlyName: 'CTA Button Text',
      defaultValue: 'Yes! I want my copy!',
    },
    {
      name: 'pdfButtonText',
      type: 'text',
      friendlyName: 'PDF Button Text',
      defaultValue: 'PDF',
    },
    {
      name: 'backgroundImage',
      type: 'file',
      friendlyName: 'Background Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/Home-Screen_Option-2.png',
    },
    {
      name: 'pdfImage',
      type: 'file',
      friendlyName: 'PDF Preview Image',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: 'https://cdn.shopify.com/s/files/1/0838/4525/files/attachment-Photoroom_1_1.png?v=1746116404',
    },
    {
      name: 'videoUrl',
      type: 'file',
      friendlyName: 'Video URL',
      allowedFileTypes: ['mp4', 'webm', 'mov'],
      defaultValue: 'https://cdn.shopify.com/videos/c/o/v/b52e1b2a5b8b4ef1a61db7ad3c949290.mp4',
    },
    {
      name: 'features',
      type: 'list',
      friendlyName: 'Feature Items',
      subFields: [
        {
          name: 'imgSrc',
          type: 'file',
          friendlyName: 'Feature Icon',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
        },
        {
          name: 'title',
          type: 'richText',
          friendlyName: 'Feature Title',
        },
      ],
      defaultValue: [
        {
          imgSrc: '/assets/images/mind-1.png',
          title: 'Crush Brain <br> Fog in 5 Min',
        },
        {
          imgSrc: '/assets/images/mind-2.png',
          title: 'Beware your <br> Brain <br> (Yes, Even You)',
        },
        {
          imgSrc: '/assets/images/mind-3.png',
          title: '4 Steps to <br> a Glow-Up Brain',
        },
        {
          imgSrc: '/assets/images/mind-4.png',
          title: 'Brainpower <br> You Can Flex IRL',
        },
      ],
    },
    {
      name: 'klaviyoListId',
      type: 'text',
      friendlyName: 'Klaviyo List ID',
      defaultValue: 'R9KL24',
    },
  ],
});
</script>

<style>
.success_message {
  background-color: #10b981;
  color: white;
  padding: 1rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: 600;
}

.error_message {
  background-color: #ef4444;
  color: white;
  padding: 1rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: 600;
}
</style>
